import request from '@/utils/request'

// 查询报单订单列表分页
export function fetchList(query) {
    return request({
        url: '/taxation/order/page',
        method: 'get',
        params: query,
    })
}
// 查询报单订单详细
export function getObj(id) {
    return request({
        url: '/taxation/order/detail?isPrint=true&orderId=' + id,
        method: 'get',
    })
}
//  
// 订单备注
export function addObj(data) {
    return request({
        url: '/taxation/order/remark',
        method: 'post',
        data: data,
    })
}
// 订单审核
export function reviewPay(data) {
    return request({
        url: '/taxation/order/review/pay',
        method: 'post',
        data: data,
    })
}
// 新增品牌报单
export function statusObj(data) {
    return request({
        url: '/taxation/brand/add',
        method: 'post',
        data: data,
    })
}
// 发货
export function putObj(data) {
    return request({
        url: '/taxation/order/deliver',
        method: 'post',
        data: data,
    })
}
// 取消报单订单
export function cancelObj(data) {
    return request({
        url: '/taxation/order/cancel',
        method: 'post',
        data: data,
    })
}
